<template>
  <v-simple-table>
    <thead>
       <tr>
        <th class="text-left" style="width: 30%;">Cuenta</th>
        <th class="text-left" style="width: 30%;">Descripción</th>
        <th class="text-right" style="width: 20%;">Debe</th>
        <th class="text-right" style="width: 20%;">Haber</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="detalle in detalles" :key="detalle.id">
        <td>
          <span v-if="detalle.cuenta">
            <span class="importe grey--text">{{ detalle.cuenta.codigo }}</span>
            {{ detalle.cuenta.nombre }}
          </span>
          <span v-else>N/A</span>
        </td>
        <td>{{ detalle.descripcion }}</td>
        <td class="text-right importe">{{ importeCelda(detalle.debe) }}</td>
        <td class="text-right importe">{{ importeCelda(detalle.haber) }}</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="2"></td>
        <td class="text-right importe font-weight-bold">
          {{ totalDebe | importe }}
        </td>
        <td class="text-right importe font-weight-bold">
          {{ totalHaber | importe }}
        </td>
      </tr>
    </tfoot>
  </v-simple-table>
</template>


<script>
import { formatearImporte, parsearImporte, sumarImportes } from "@/util/importe";

export default {
  name: "AsientoTipoDetalleItem",
  components: {},
  props: {
    detalles: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    totalDebe() {
      return sumarImportes(this.detalles.map((d) => d.debe));
    },
    totalHaber() {
      return sumarImportes(this.detalles.map((d) => d.haber));
    },
  },
  methods: {
    /** Celda vacía en lugar de 0: el contador lee la columna en vertical. */
    importeCelda(valor) {
      const numero = parsearImporte(valor);
      return numero === 0 ? "" : formatearImporte(numero);
    },
  },
};
</script>

<style scoped>
/* Cifras con ancho de dígito fijo: las columnas se leen en vertical. */
.importe {
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";
  white-space: nowrap;
}
</style>

